import React, { JSX, useState } from 'react';
import styled from 'styled-components';
import OpenIcon from '../../../assets/selectOpen.svg'
import CloseIcon from '../../../assets/select.svg'
import Trash from '../../../assets/trash.svg'
import Edit from '../../../assets/edit.svg'

interface Option {
  label: string;
  value: string;
}

interface FormSelectProps {
  id?: string;
  name?: string;
  items: Option[];
  initialValue?: string[];
  onChange?: (value: string[]) => void;
  onBlur?: () => void;
  onFocus?: () => void;
  required?: boolean;
  appendTo?: string;
  border?: boolean;
  className?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
  autoFocus?: boolean;
  multiple?: boolean;
  value?: string | string[];
  placeholder?: string;
  setIsOpen: (isOpen: boolean) => void;
  itemTemplate?: (option: Option) => JSX.Element;
  removePlatformGroup: (id: string) => Promise<void>;
  setSelectedValues: (selectedValues: string[]) => void;
  selectedValues: string[]
  label?: React.ReactNode;
  tooltip?: React.ReactNode;
  top?: boolean;
  text: string;
  setEditId?: (id: string | null) => void
  editIcon?: boolean;
  setEditValue?: (value: string[]) => void
  editValue?: string[];
  setDropdownOpen: (open: boolean) => void;
  dropdownOpen: boolean;
  styleNone?: boolean;

}


export const FormSelect: React.FC<FormSelectProps> = ({ items, placeholder, setIsOpen, removePlatformGroup, setSelectedValues, selectedValues, top = false, text, setEditId = ((() => null)), editIcon = false, setEditValue, dropdownOpen, setDropdownOpen, styleNone = true, editValue }) => {
  const [filterText, setFilterText] = useState('');
  const allValues = items.map((i) => i.value);
  const allSelected = allValues.length ? allValues.every((v) => selectedValues.includes(v)) : false;


  const toggleSelectAll = () => {
    setSelectedValues(allSelected ? [] : allValues);
  };


  const toggleValue = (value: string) => {
    if (selectedValues.includes(value)) {
      setSelectedValues(selectedValues.filter((v) => v !== value));
    } else {
      setSelectedValues([...selectedValues, value]);
    }
  };
  const filteredItems = items.filter(
    (i) =>
      i.value === 'all' ||
      i.label.toLowerCase().includes(filterText.toLowerCase())
  )

  return (
    <Container>
      <InputArea onClick={() => setDropdownOpen(!dropdownOpen)}>
        {placeholder}
        <span>
          {dropdownOpen ? <OpenIcon /> : <CloseIcon />}
        </span>
      </InputArea>
      {dropdownOpen && (
        <Dropdown style={styleNone ? { top: top ? '-400px' : '37px' } : {}}>
          <FilterContainer>
            <FilterInput
              placeholder="Enter the group name"
              value={filterText}
              onChange={(e) => setFilterText(e.target.value)}
            />
          </FilterContainer>
          <SelectAllContainer>
            <Checkbox
              type="checkbox"
              checked={allSelected}
              readOnly
              onClick={toggleSelectAll}
            />
            <SelectAllLabel onClick={toggleSelectAll}>Select All</SelectAllLabel>
          </SelectAllContainer>
          <OptionsContainer>
            {filteredItems.map((item) => (
              <OptionItem
                key={item.value}
                onClick={() => toggleValue(item.value)}
                selected={selectedValues.includes(item.value)}
              ><div style={{ display: 'flex', alignItems: 'center' }}>
                  <Checkbox type="checkbox" checked={selectedValues.includes(item.value)} readOnly />
                  <OptionLabel>{item.label}</OptionLabel>
                </div>
                <div>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    {editIcon && (
                      <div
                        onClick={(ev) => {
                          ev.stopPropagation();
                          if (editValue) {
                            //@ts-ignore
                            setEditValue([item.value]);
                          } else {
                            setSelectedValues([item.value]);
                          }
                          setEditId(item.label);
                          setIsOpen(true);
                        }}
                      >
                        <Edit />
                      </div>
                    )}
                    <div
                      onClick={(ev) => {
                        ev.stopPropagation();
                        removePlatformGroup(item.value);
                      }}
                    >
                      <Trash />
                    </div>
                  </div>

                </div>
              </OptionItem>
            ))}
          </OptionsContainer>
          <Footer>
            <AddButton onClick={() => setIsOpen(true)}>{text}</AddButton>
          </Footer>
        </Dropdown>
      )}
    </Container>
  );
};

const Container = styled.div`
  width: 300px;
  position: relative;
  font-family: Arial, sans-serif;
`;

const InputArea = styled.div`
  display:flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 15px 7px 15px;
  cursor: pointer;
  border-radius: 6px;
  border:1px solid #000000;
`;

const Dropdown = styled.div`
  width:364px;
  height: max-content;
  position: absolute;
  // top: 100%;
  left: 0;
  border: 1px solid #ccc;
  border-radius: 10px;
  background: #fff;
  z-index: 10;
  padding: 19px 13px 0 12px;
  bottom:37px;
`;

const FilterContainer = styled.div`
  padding: 8px;
`;

const FilterInput = styled.input`
  width: 100%;
  padding: 10px 0 11px 9px;
  border-radius: 8px;
  border: 1px solid #ccc;
  border:1px solid #E9E9E9;
  outline:none;
`;

const SelectAllContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 8px;
  border-bottom: 1px solid #eee;
  gap: 11px;
`;

const SelectAllLabel = styled.label`
  cursor: pointer;
  font-family: SF Pro Display;
  font-weight: 500;
  font-style: Medium;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0%;
  vertical-align: middle;
  color:#000000;
`;

const OptionsContainer = styled.div`
  width:100%
  padding:10px 0;
  max-height: 200px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap:8px;
`;


const OptionItem = styled.div<{ selected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 8px;
  background: ${(props) => (props.selected ? '#f0f4ff' : 'transparent')};
  cursor: pointer;

  &:hover {
    background: #f0f4ff;
  }
`;

const OptionLabel = styled.span`
  margin-left: 6px;
  font-family: SF Pro Display;
  font-weight: 500;
  font-style: Medium;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0%;
  vertical-align: middle;
`;

const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 1px solid #6777FF;
  appearance: none;
  cursor: pointer;
  position: relative;
  background-color: ${(props) => (props.checked ? '#6777FF' : '#fff')};

  &:checked::after {
    content: '';
    position: absolute;
    top: 2px;
    left: 6px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    border-width: 0 1px 1px 0;
  }
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  height:60px;
  padding: 13px 12px 9px 0;
  border-top: 1px solid #eee;
`;

const AddButton = styled.button`
  padding: 6px 12px;
  border-radius: 6px;
  background-color: #6777ff;
  color: #fff;
  border: none;
  cursor: pointer;

  &:hover {
    background-color: #5566e0;
  }
`;
